import { motion } from "framer-motion";
import { FAQS } from "../data/content";

const Tile = ({ faq, index, onOpen }) => (
    <motion.button
        data-testid={`faq-tile-${faq.id}`}
        onClick={() => onOpen(index)}
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.55 + index * 0.045, duration: 0.4, ease: "easeOut" }}
        whileHover={{ y: -3 }}
        className="group relative flex w-full h-full min-h-0 flex-col justify-between rounded-xl border border-slate-200/80 bg-white p-3 sm:p-4 text-left shadow-[0_2px_8px_-2px_rgba(15,23,42,0.04)] transition-colors duration-200 hover:border-teal-600/70 hover:bg-teal-50/40"
    >
        <span className="font-mono2 text-xs font-semibold tracking-widest text-red-600 transition-transform duration-200 group-hover:scale-110 origin-left">
            {faq.id}
        </span>
        <span className="font-heading text-[11px] sm:text-xs font-bold leading-snug text-slate-800">
            {faq.question}
        </span>
        <span className="absolute right-3 top-3 h-1.5 w-1.5 rounded-full bg-slate-200 transition-colors duration-200 group-hover:bg-teal-500" />
    </motion.button>
);

export const FaqBento = ({ onOpen }) => (
    <div
        data-testid="faq-bento-grid-container"
        className="grid h-full min-h-0 flex-1 grid-cols-2 grid-rows-5 gap-3 overflow-hidden sm:grid-cols-5 sm:grid-rows-2 lg:gap-4"
    >
        {FAQS.map((faq, i) => (
            <Tile key={faq.id} faq={faq} index={i} onOpen={onOpen} />
        ))}
    </div>
);
